import React from 'react';
import { CFBaseIconVariant } from '../utilities';
export const CFIconCaretUp = {
    alias: 'caret-up',
    defaultTitle: 'Caret Up',
    source: ({ Path }, { variant }) => variant === CFBaseIconVariant.FILLED ? (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M16.214 16H7.788c-.673 0-1.28-.402-1.585-1.049a2.087 2.087 0 0 1 .258-2.21l4.214-5.099c.672-.817 1.98-.817 2.652 0l4.213 5.098c.504.611.605 1.478.26 2.211-.306.647-.913 1.049-1.586 1.049Z' }))) : (React.createElement(React.Fragment, null,
        React.createElement(Path, { d: 'M8.016 14h7.895L12 9.178 8.016 14Zm8.198 2H7.788c-.672 0-1.28-.402-1.585-1.049a2.087 2.087 0 0 1 .258-2.21l4.214-5.099c.672-.817 1.981-.817 2.652 0l4.213 5.098c.504.611.605 1.478.26 2.211-.306.647-.913 1.049-1.586 1.049Z' }))),
};
